import { getRoutes } from '@ui-framework/index';
import AuthorizationWrapper, {
  authFnAllowOnlySAForMaintenance,
} from '@product-framework/components/AuthorizationWrapper';
import ServiceAdministratorServiceTypeEdit from './pages/edit/index';
import ServiceAdministratorServiceTypeCreate from './pages/create/index';
import ServiceAdministratorServiceTypeList from './pages/list/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

import ServiceAdministratorServiceTypeFormStore from './store/index';

const Pages = ProtectedRoute => ({
  ServiceAdministratorServiceTypeEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceAdministratorServiceTypeEdit}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySAForMaintenance],
      }}
    />
  ),
  ServiceAdministratorServiceTypeCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceAdministratorServiceTypeCreate}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySAForMaintenance],
      }}
    />
  ),
  ServiceAdministratorServiceTypeList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceAdministratorServiceTypeList}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySAForMaintenance],
      }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  {
    serviceadministratorservicetypeFormStore:
      new ServiceAdministratorServiceTypeFormStore(rootStore),
  },
];

export {
  ServiceAdministratorServiceTypeEdit,
  ServiceAdministratorServiceTypeCreate,
  ServiceAdministratorServiceTypeList,
  routes,
  stores,
};
